import { Link } from "react-router-dom/cjs/react-router-dom.min";

const ProjectItem = ({ item }) => {
  return (
    <div
      data-aos="zoom-in"
      data-aos-delay="50"
      data-aos-duration="1000"
      className="card projectitem__card col-lg-3 col-md-3 col-sm-12"
    >
      <img src={item.cover} className="card-img-top" alt={item.title} />

      <div className="card-body d-flex flex-column">
        <h2 className="projectitem__title">{item.title}</h2>
        <div className="sm-space"></div>
        <p className="projectitem__description">{item.descrption}</p>
        <div className="sm-space"></div>

        <div class="row mt-auto ml-auto mr-auto">
          {item.hasURL && (
            <a
              href={item.project_web}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-action-fill btn-radius m-1 "
            >
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </a>
          )}

          {item.hasContent ? (
            <Link
              to={item.project_link}
              className="btn btn-action-fill btn-radius m-1"
            >
              Read More
            </Link>
          ) : (
            <a
              href={item.project_link}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-action-fill btn-radius m-1 "
            >
              <i className="fab fa-github space-right" aria-hidden="true"></i>{" "}
              {/* Code */}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectItem;
